const KillingMeSoftly = [
	'[Chorus]',
	'Strumming my pain with his fingers. Singing my life with his words.',
	'Killing me softly with his song. Killing me softly with his song.',
	'Telling my whole life with his words.',
	'Killing me softly, with his song.',
	'',
	'[Verse 1]',
	'I heard he sang a good song.',
	'I heard he had a style.',
	'And so I came to see him,',
	'and listen for a while.',
	'And there he was this young boy,',
	'a stranger to my eyes.',
	'',
	'[Chorus]',
	'Strumming my pain with his fingers. Singing my life with his words.',
	'Killing me softly with his song. Killing me softly with his song.',
	'Telling my whole life with his words.',
	'Killing me softly, with his song.',
	'',
	'[Verse 2]',
	'I felt all flushed with fever,',
	'embarrassed by the crowd.',
	'I felt he found my letters',
	'and read each one out loud.',
	'I prayed that he would finish,',
	'but he just kept right on.',
	'',
	'[Chorus]',
	'Strumming my pain with his fingers. Singing my life with his words.',
	'Killing me softly with his song. Killing me softly with his song.',
	'Telling my whole life with his words.',
	'Killing me softly, with his song.',
	'',
	'[Chorus]',
	'Strumming my pain with his fingers. Singing my life with his words.',
	'Killing me softly with his song. Killing me softly with his song.',
	'Telling my whole life with his words.',
	'Killing me softly, with his song.',
];

export default KillingMeSoftly;
